export const RESTAURANT_LAYOUT_FIELDS = {
    stack: {
        "restaurant-header": [
            "announcementPill",
            "announcementSubtext",
            "announcementText",
            "ctaLabel",
            "showAnnouncement",
            "tagline",
        ],
        // No `eyebrow`: STACK's hero is a headline and a subhead, and the artboard
        // has nothing above them.
        "restaurant-hero": ["headline", "primaryCta", "secondaryCta", "subhead"],
        "restaurant-menu": [
            "featuredTitle",
            "showDescriptions",
            "showImages",
            "showSectionNav",
        ],
        // The club strip prints its NAME and nothing else — the artboard's band is
        // a wordmark and a button, with no room for a sentence.
        "restaurant-rewards": ["programmeName"],
        "restaurant-footer": ["address", "hours", "legalLine", "locationsLine"],
    },
    homegrill: {
        "restaurant-header": ["ctaLabel", "signInLabel"],
        "restaurant-hero": [
            "eyebrow",
            "headline",
            "primaryCta",
            "secondaryCta",
            "subhead",
        ],
        "restaurant-menu": [
            "featuredTitle",
            "showDescriptions",
            "showImages",
            "showSectionNav",
        ],
        "restaurant-rewards": ["headline", "programmeName"],
        "restaurant-footer": ["address", "hours", "legalLine", "locationsLine"],
    },
    verde: {
        "restaurant-header": ["ctaLabel"],
        "restaurant-hero": [
            "eyebrow",
            "headline",
            "primaryCta",
            "secondaryCta",
            "subhead",
        ],
        // One title. VERDE's menu is a single authored band, so the image and
        // description switches have nothing to switch.
        "restaurant-menu": ["featuredTitle"],
        "restaurant-rewards": ["headline", "programmeName"],
        "restaurant-footer": ["address", "hours", "legalLine", "locationsLine"],
    },
    koyo: {
        "restaurant-header": ["ctaLabel", "tagline"],
        "restaurant-hero": [
            "eyebrow",
            "headline",
            "primaryCta",
            "secondaryCta",
            "subhead",
        ],
        "restaurant-menu": ["featuredTitle", "showDescriptions", "showImages"],
        "restaurant-rewards": ["headline", "programmeName"],
        "restaurant-footer": ["address", "hours", "legalLine", "locationsLine"],
    },
    otto: {
        "restaurant-header": ["ctaLabel", "tagline"],
        "restaurant-hero": [
            "eyebrow",
            "headline",
            "primaryCta",
            "secondaryCta",
            "subhead",
        ],
        // No image switch: OTTO's menu is dotted leaders running to a price, and it
        // has no photographs to turn off.
        "restaurant-menu": ["featuredTitle", "showDescriptions"],
        "restaurant-rewards": ["headline", "programmeName"],
        "restaurant-footer": ["address", "hours", "legalLine", "locationsLine"],
    },
    bru: {
        "restaurant-header": ["ctaLabel", "signInLabel", "tagline"],
        "restaurant-hero": [
            "eyebrow",
            "headline",
            "primaryCta",
            "secondaryCta",
            "subhead",
        ],
        "restaurant-menu": ["featuredTitle", "showDescriptions", "showImages"],
        "restaurant-rewards": ["headline", "programmeName"],
        "restaurant-order-cta": ["label", "note"],
        "restaurant-footer": ["address", "hours", "legalLine", "locationsLine"],
    },
};
/** True when this layout's skin renders that setting at all. */
export function layoutRendersField(layout, sectionType, fieldId) {
    const known = RESTAURANT_LAYOUT_FIELDS[layout];
    // An unknown layout is not a reason to hide everything: a theme this build
    // has never heard of should still offer its schema's fields rather than an
    // empty panel.
    if (!known)
        return true;
    return (known[sectionType] ?? []).includes(fieldId);
}
//# sourceMappingURL=restaurant-layout-fields.js.map